import './btn.scss';

function Btn(props) {
  return (
    <a id='btnLink' href={props.link} target='_blank' rel='noreferrer'>
        <input className={props.class} type='button' value={props.value}></input>
    </a>
  );
}

export default Btn;